export const theme = {
  name: "light",
  breakpoints: {
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px",
    xxl: "1400px",
  },
  fonts: {
    body: "'Montserrat', 'Noto Sans TC', 'Noto Sans SC', 'Microsoft YaHei', STXihei, Helvetica, Arial, sans-serif",
    heading:
      "'Montserrat', 'Noto Sans TC', 'Noto Sans SC', 'Microsoft YaHei', STXihei, Helvetica, Arial, sans-serif",
  },
  colors: {
    black: "#353535",
    darkBlue: "#032934",
    red: "#A92223",
    gray: "#b1b1b1",
    darkGrey: "#787878",
    lightGray: "#ebebeb",
    white: "#fff",
  },
  sideBarWidth: {
    lg: 24,
    xl: 28,
    xxl: 32,
  },
  pageContainerWidth: {
    xs: 1.2,
    sm: 1.8,
    md: 2.4,
    lg: 1.6,
    xl: 3,
    xxl: 4,
  },
  gutterWidth: {
    xs: 1.2,
    sm: 1.8,
    md: 2.4,
    lg: 3.2,
    xl: 4,
    xxl: 6,
  },
  zIndex: {
    header: 1000,
    burger: 2000,
  },
};

export const when = (breakpoint) =>
  `@media (min-width: ${theme.breakpoints[breakpoint]})`;

export default theme;
